var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconBottomtabProfileActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.8663 27.5C28.7785 27.652 28.6522 27.7783 28.5001 27.8661C28.3481 27.9538 28.1756 28 28 28H4.00001C3.82456 27.9998 3.65225 27.9535 3.50037 27.8656C3.3485 27.7778 3.2224 27.6515 3.13476 27.4995C3.04711 27.3475 3.00099 27.1752 3.00104 26.9997C3.00108 26.8243 3.04729 26.6519 3.13501 26.5C5.03876 23.2087 7.97251 20.8487 11.3963 19.73C9.70272 18.7218 8.38695 17.1856 7.651 15.3572C6.91505 13.5289 6.79962 11.5095 7.32244 9.60918C7.84526 7.70887 8.97741 6.03272 10.545 4.83814C12.1127 3.64355 14.0291 2.99658 16 2.99658C17.9709 2.99658 19.8874 3.64355 21.455 4.83814C23.0226 6.03272 24.1548 7.70887 24.6776 9.60918C25.2004 11.5095 25.085 13.5289 24.349 15.3572C23.6131 17.1856 22.2973 18.7218 20.6038 19.73C24.0275 20.8487 26.9613 23.2087 28.865 26.5C28.953 26.6519 28.9994 26.8243 28.9996 26.9998C28.9998 27.1754 28.9538 27.3479 28.8663 27.5Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconBottomtabProfileActive);
export default __webpack_public_path__ + "static/media/icon_bottomtab_profile_active.53f2cdea629d1fbb7107bb5c080be2a0.svg";
export { ForwardRef as ReactComponent };